import React from 'react';
import { Car, Phone, MapPin, Heart, Star } from 'lucide-react';
import { useFavoriteTaxiStands } from '../hooks/useFavoriteTaxiStands';

export default function FavoriteTaxiStands() {
  const { favorites, removeFavorite } = useFavoriteTaxiStands();

  if (favorites.length === 0) {
    return null;
  }

  return (
    <div className="bg-gray-800/40 backdrop-blur-xl rounded-xl p-4 border border-white/5">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2.5 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
          <Heart className="w-5 h-5 fill-black stroke-yellow-400 stroke-2" />
        </div>
        <h2 className="text-base font-bold text-white">Favori Duraklar</h2>
      </div>

      <div className="space-y-3">
        {favorites.map((stand) => (
          <div
            key={stand.id}
            className="bg-gray-800/50 rounded-lg overflow-hidden border border-white/5 hover:border-red-400/20 transition-all duration-300"
          >
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Car className="w-5 h-5 text-gray-900" />
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <h3 className="text-white text-sm font-medium truncate">{stand.name}</h3>
                        <div className="flex items-center gap-1 bg-yellow-400/10 px-2 py-0.5 rounded-full">
                          <Star className="w-3 h-3 text-yellow-400 fill-current" />
                          <span className="text-xs font-medium text-yellow-400">
                            {stand.rating.toFixed(1)}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 mt-1">
                        <MapPin className="w-3 h-3 text-gray-400" />
                        <p className="text-xs text-gray-400 truncate">{stand.address}</p>
                      </div>
                    </div>
                    <button
                      onClick={() => removeFavorite(stand.id)}
                      className="p-1.5 rounded-lg bg-gray-700/50 hover:bg-gray-700 transition-colors"
                    >
                      <Heart className="w-4 h-4 text-red-400 fill-red-400" />
                    </button>
                  </div>
                </div>
              </div>
              
              <a
                href={`tel:${stand.phone}`}
                className="block w-full mt-3 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 text-sm font-medium rounded-lg transition-all active:scale-[0.98]"
              >
                <div className="px-3 py-2 flex items-center justify-center gap-1.5">
                  <Phone className="w-3.5 h-3.5" />
                  <span>Taksi Çağır</span>
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}